import api from '..'

import { IGeneralAPI } from 'store/states/general.state'

const updateGeneralSettings = (data: Partial<IGeneralAPI>) => {
  return api.put('administration/general/settings', data)
}

export default updateGeneralSettings
